import React, { useState, useEffect } from 'react';
import { Button, CircularProgress } from '@mui/material';

interface PVLoadingButtonProps {
  children: React.ReactNode | string;
  color?: 'inherit' | 'primary' | 'secondary';
  component?: React.ElementType;
  disabled?: boolean;
  fullWidth?: boolean;
  forceLoading?: boolean;
  testId?: string;
  variant?: 'contained' | 'outlined' | 'text';
  onClick?: (e: any) => void | Promise<void> | Promise<any> | null;
}

export const PVLoadingButton = ({
  children,
  color = 'secondary',
  component = 'button',
  disabled = false,
  forceLoading = false,
  fullWidth = false,
  testId = '',
  variant = 'contained',
  onClick = () => null,
}: PVLoadingButtonProps) => {
  const [isLoading, setIsLoading] = useState(forceLoading);
  useEffect(() => {
    setIsLoading(forceLoading);
  }, [forceLoading]);

  const isDisabled = disabled || isLoading;

  const handleClick = async (e: any) => {
    if (onClick) {
      setIsLoading(true);
      await onClick(e);
      setIsLoading(false);
    }
  };

  return (
    <Button
      component={component}
      data-cy={testId}
      disabled={isDisabled}
      fullWidth={fullWidth}
      onClick={handleClick}
      variant={variant}
      color={color}
      endIcon={
        (forceLoading || isLoading) && (
          <CircularProgress size={24} sx={{ color: 'inherit' }} />
        )
      }
    >
      {children}
    </Button>
  );
};
